var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[(_vm.loading)?_c('div',{staticClass:"text-right p-4 position-absolute w-100",staticStyle:{"z-index":"1"}},[_c('div',{staticClass:"spinner-border text-secondary",attrs:{"role":"status"}})]):_vm._e(),_c('div',{staticStyle:{"min-height":"calc(100vh - 135px)"},attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }